/**
 * Combine
 * A simple jQuery function to combine multiple selection objects into one.
 * Ex: $.combine($('selector1'), $('selector2'));
 */
(function($){
	$.combine = function() {
		var $jQ = $();
		$.each(arguments, function(i, val){
			$jQ = $jQ.add(val);
		});
		return $jQ;
	};
})(jQuery);